import {
  CASE_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  CASE_ESCALATE_CASE,
  CASE_ESCALATION_TOGGLE_MODAL,
  CASE_GET_CASE,
  CASE_SET_ACTIVITY,
  CASE_SET_DESC_ERROR,
  CASE_SET_ERRORS,
  CASE_SET_ESCALATION_MODAL_ERROR_TEXT,
  TICKET_SET_COMMENT_PROCESSING,
  TICKET_SET_COMMENT_VALUE,
  TICKET_SET_SHOW_COMMENT_FORM,
  CASE_TOGGLE_ACTIVITY_CONTENT_LOADING,
  CASE_TOGGLE_ACTIVITY_IS_OPEN,
  CASE_TOGGLE_ESCALATION_MODAL_LOADING,
  CASE_TOGGLE_LOADING,
  CASE_TOGGLE_MODAL,
  CASE_TOGGLE_MODAL_LOADING,
  CASE_UPDATE_ESCALATION_NOTE,
  CaseActionTypes,
  ICaseState,
  TOGGLE_CASE_REASON_DROPDOWN, TICKET_SET_ACTIVITY_ERROR,
} from './types';

export const initialState: ICaseState = {
  loading: false,
  readOnly: true,
  showCommentForm: false,
  commentValue: '',
  descError: false,
  commentProcessing: false,
  reasonDropdownOpen: false,
  caseModalLoading: false,
  escalationcaseModalLoading: false,

  data: {
    id: '',
    ticketNumber: '',
    title: '',
    description: '',
    status: '',
    state: '',
    escalationState: '',
    createdOn: new Date(),
    modifiedOn: new Date(),
    origin: '',
    priority: '',
    openedBy: '',
    activities: [],
    assignedTo: '',
    escalationNote: '',
    modalOpen: false,
    escalationModalOpen: false,
    escalateModalErrorText: '',
    caseWorker: {
      firstName: '',
      lastName: '',
      name: '',
      email: '',
      phone: null,
    },
  },
  errors: [],
};
export function caseReducer(state = initialState, action: CaseActionTypes) {

  switch (action.type) {
    case CASE_TOGGLE_MODAL_LOADING: {

      return {
        ...state,
        caseModalLoading: !state.caseModalLoading,

      };

    }

    case CASE_TOGGLE_ESCALATION_MODAL_LOADING: {

      return {
        ...state,
        escalationcaseModalLoading: !state.escalationcaseModalLoading,
      };

    }

    case CASE_ESCALATE_CASE: {

      return {
        ...state,
        data: {
          ...state.data, escalationState: 'Escalated',
        },
      };

    }
    case TOGGLE_CASE_REASON_DROPDOWN:

      return {
        ...state,
        reasonDropdownOpen: !state.reasonDropdownOpen,
      };

    case CASE_SET_ESCALATION_MODAL_ERROR_TEXT:
      return {
        ...state,
        data: {
          ...state.data, escalateModalErrorText: action.payload,
        },
      };
    case CASE_TOGGLE_MODAL:
      return {
        ...state,
        data: {
          ...state.data, modalOpen: !state.data.modalOpen,
        },
      };
    case CASE_ESCALATION_TOGGLE_MODAL:
      return {
        ...state,
        data: {
          ...state.data, escalationModalOpen: !state.data.escalationModalOpen, escalationNote: '', escalateModalErrorText: '',
        },
      };
    case CASE_UPDATE_ESCALATION_NOTE:
      return {
        ...state,
        data: { ...state.data, escalationNote: action.payload, escalateModalErrorText: '' },
      };
    case CASE_GET_CASE:
      return {
        ...state,
        data: action.data,
        dataOriginal: action.data,
      };
    case CASE_SET_ERRORS:
      return {
        ...state,
        errors: [...action.errors],
      };
    case CASE_TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case CASE_ASSIGN_ACTIVITY_IS_OPEN_FIELDS:
      return {
        ...state,
        data: { ...state.data, activities: state.data.activities.map((activity) => ({ ...activity, isOpen: false })) },
      };
    case CASE_TOGGLE_ACTIVITY_IS_OPEN:
      const { data } = state;
      const { activities } = data;
      const { id } = action;
      const updatedActivities = activities.map((activity) => {

        if (activity.id === id) {

          return { ...activity, isOpen: !activity.isOpen };

        }

        return activity;

      });
      return {
        ...state,
        data: { ...state.data, activities: [...updatedActivities] },
      };
    case CASE_TOGGLE_ACTIVITY_CONTENT_LOADING:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {

            if (activity.id === action.id) {

              return { ...activity, contentLoading: !activity.contentLoading };

            }

            return activity;

          }),
        },
      };
    case TICKET_SET_ACTIVITY_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {

            if (activity.id === action.id) {

              return { ...activity, error: action.error };

            }

            return activity;

          }),
        },
      };
    case TICKET_SET_SHOW_COMMENT_FORM:
      return {
        ...state, showCommentForm: !state.showCommentForm,
      };
    case TICKET_SET_COMMENT_VALUE:
      return {
        ...state, commentValue: action.value,
      };
    case CASE_SET_DESC_ERROR:
      return {
        ...state, descError: action.payload,
      };
    case TICKET_SET_COMMENT_PROCESSING:
      return {
        ...state,
        commentProcessing: action.payload,
      };
    case CASE_SET_ACTIVITY:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {

            if (activity.id === action.data.id) {

              return { ...activity, ...action.data };

            }

            return activity;

          }),
        },
      };
    default:
      return state;
  }

}
